import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AuthPageLayout from "../../../components/layout/AuthPageLayout";
import { images } from "../../../assets";
import { selectUserRoleId } from "../../../store/selectors/authSelectors";
import { getPostLoginRoute } from "../../../utils/routeUtils";
import {
  BackupCodesSuccessContainer,
  BackupCodesSuccessIcon,
  BackupCodesSuccessTitle,
  BackupCodesSuccessSubtitle,
  BackupCodesSuccessActions,
} from "./SuccessPage.styled";

const SuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const roleId = useSelector(selectUserRoleId);

  const handleGoToDashboard = () => {
    navigate(getPostLoginRoute(roleId));
  };

  return (
    <AuthPageLayout contentWidth="640px">
      <BackupCodesSuccessContainer>
        <BackupCodesSuccessIcon>
          <Box
            component="img"
            src={images.lockedDocument}
            alt="Backup codes saved icon"
            sx={{ width: "126px" }}
          />
        </BackupCodesSuccessIcon>

        <BackupCodesSuccessTitle>
          {t("backupCodesSuccess.title")}
        </BackupCodesSuccessTitle>

        <BackupCodesSuccessSubtitle>
          {t("backupCodesSuccess.subtitle")}
        </BackupCodesSuccessSubtitle>

        <BackupCodesSuccessActions>
          <Button
            variant="contained"
            onClick={handleGoToDashboard}
            sx={{ minWidth: 200 }}
          >
            {t("backupCodesSuccess.goToDashboard")}
          </Button>
        </BackupCodesSuccessActions>
      </BackupCodesSuccessContainer>
    </AuthPageLayout>
  );
};

export default SuccessPage;
